import { z } from 'zod';
import { companySchema } from './company-schema';
import { imageSchema } from './image-schema';
import { locationSchema } from './location-schema';
import { metaSchema } from './meta-schema';
import { officeSchema } from './office-schema';
import { pageConfigurationSchema } from './page-configuration-schema';
import { personSchema } from './person-schema';

export type TDistrict = z.infer<typeof districtSchema>;

export const districtSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    background: imageSchema,
    location: locationSchema,
    companies: z.object({
      data: z.array(companySchema),
    }),
    offices: z.object({
      data: z.array(officeSchema),
    }),
    people: z.object({
      data: z.array(personSchema),
    }),
    configuration: pageConfigurationSchema,
    meta: metaSchema,
  }),
});
